<template>
  <CCol col="12" xl="12" class="p-0">
    <CCard class="p-0">
      <CCardHeader
        class="d-flex justify-content-between align-items-center bg-secondary"
      >
        <h5 class="text-light m-0 p-0">حساب کاربری</h5>
      </CCardHeader>

      <CAlert :show.sync="dismissCountDown" closeButton color="warning" fade>
        <strong class="rounded-circle mx-2 text-info">{{
          dismissCountDown
        }}</strong>
        {{ alertText }}
      </CAlert>

      <CForm class="needs-validation p-2" novalidate>
        <CRow class="align-items-center">
          <CCol class="col-3" style="width: 150px; height: 150px">
            <CImg
              :src="info.userImage"
              class="rounded-circle p-1"
              style="
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                width: 140px;
                height: 140px;
              "
            />
          </CCol>

          <CCol class="col-9">
            <CInput
              class="col-sm-12 col-md-12 col-lg-6 mt-sm-4 mt-md-4 mt-4"
              label="نام کاربری"
              type="text"
              v-model="info.userName"
              :value="info.userName"
            />
          </CCol>
        </CRow>

        <h5 class="text-primary my-3 mt-4">اطلاعات فردی</h5>
        <hr />

        <CRow class="mt-3">
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="نام و نام خانوادگی"
            type="text"
            v-model="info.firstAndLastName"
            :value="info.firstAndLastName"
          />

          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="نام پدر"
            type="text"
            v-model="info.fatherName"
            :value="info.fatherName"
          />
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="کدملی"
            type="text"
            v-model="info.codeMeli"
            :value="info.codeMeli"
          />

          <div role="group" class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label for="uid-vvb5dt2i0jd" class="">تاریخ تولد </label
            ><date-picker
              class="col-sm-12 col-md-6 col-lg-4 p-0 m-0"
              v-model="info.dateOfBirth"
              :value="info.dateOfBirth"
              >تاریخ تولد</date-picker
            >
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label class="typo__label">جنسیت</label>
            <multiselect
              v-model="info.gender"
              :options="genderList"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
            ></multiselect>
          </div>

          <h5 class="text-primary my-3">اطلاعات تماس</h5>
          <hr />

          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="تلفن همراه"
            placeholder="مثال (4565***0912)"
            type="number"
            maxlength="11"
            v-model="info.phoneNumber"
            :value="info.phoneNumber"
          />

          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="تلفن ثابت"
            placeholder="مثال (5114****024)"
            type="number"
            maxlength="11"
            v-model="info.telephoneNumber"
            :value="info.telephoneNumber"
          />

          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="ایمیل"
            type="email"
            v-model="info.email"
            :value="info.email"
          />
        </CRow>
      </CForm>
    </CCard>

    <!-- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف کاربر'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف کاربر'"
          @click="deleteUser"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </CCol>
</template>

<style></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Multiselect from "vue-multiselect";
import axios from "axios";
import { Values } from "../../commonValues";
import $ from "jquery";

export default {
  data() {
    return {
      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",

      info: {
        userImage: "",
        userName: "",
        firstAndLastName: "",
        fatherName: "",
        codeMeli: "",
        dateOfBirth: "",
        gender: { label: "", value: "" },
        active: { label: "", value: "" },
        phoneNumber: "",
        telephoneNumber: "",
        email: "",
      },

      officeList: [],
      StatusList: [],
      disableMultiselect: false,

      dismissCountDown: 0,
      alertText: "",

      genderList: [
        {
          value: "true",
          label: "مرد",
        },
        {
          value: "false",
          label: "زن",
        },
      ],

      preview: null,
      image: null,
    };
  },

  components: {
    datePicker: VuePersianDatetimePicker,
    Multiselect,
  },

  mounted() {
    // get user data from server
    const config = { headers: { "Content-Type": "application/json" } };
    axios
      .post(
        Values.serverIp + "User/GetUserByUserName",
        localStorage.getItem("username"),
        config
      )
      .then((response) => {
        if (response.status == 200) {
         
          this.info.firstAndLastName = response.data.firstAndLastName;
          this.info.fatherName = response.data.fatherName;
          this.info.codeMeli = response.data.codeMeli;
          this.info.dateOfBirth = response.data.dateOfBirth;
          this.info.email = response.data.email;
          this.info.phoneNumber = response.data.phoneNumber;
          this.info.telephoneNumber = response.data.telephoneNumber;
          this.info.userName = response.data.userName;
          this.info.password = response.data.password;
          this.info.userImage= Values.serverIp + response.data.userImage;

          this.setGenderValue(JSON.stringify(response.data.gender));

          response.data.active == true
            ? (this.info.active.value = 1)
            : (this.info.active.value = 2);

          // make all part to disabled
          $(".form-check, .form-control-file, .form-control").attr(
            "disabled",
            true
          );
          this.disableMultiselect = true;
        } else {
          // modal unsuccessful edit change
          (this.alertModal = true),
            (this.alertModalTitle = "خطایی رخ داده"),
            (this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
            (this.alertModalColor = "danger"),
            (this.alertModalButtonText = "تایید");
        }
      })
      .catch((response) => {
        if (response.status != 200) {
          // modal unsuccessful edit change
          this.alertModal = true;
          this.alertModalTitle = "خطایی رخ داده";
          this.alertModalText =
            "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
          (this.alertModalColor = "info"),
            (this.alertModalButtonText = "تایید");
        }
      });
  },

  methods: {
    setGenderValue(data) {
      for (var i = 0; i < this.genderList.length; i++) {
        if (this.genderList[i].value == data) {
          this.info.gender.label = this.genderList[i].label;
          this.info.gender.value = this.genderList[i].value;
        }
      }
    },
  },
};
</script>
